import {Api, apiMixin, ConfigHelper, createApiService} from 'relapp-api';

export default {
    ...createApiService('ssl'),

    validateCsr(csr, domain) {
        const route = ConfigHelper.apiUrl('ssl.csr.validate');
        return Api.post(route,
            {
                csr: csr,
                domain: domain
            })
    },
    submitReissue(csr, domain) {
        const route = ConfigHelper.apiUrl('ssl.reissue');
        return Api.post(route,
            {
                csr: csr,
                domain: domain
            })
    },
    validatePrivateKey(domain, privateKey) {
        const route = ConfigHelper.apiUrl('ssl.privatekey.validate');
        return Api.post(route,
            {
                domain: domain,
                privateKey: privateKey
            });
    },
    submitPrivateKey(domain, privateKey) {
        const route = ConfigHelper.apiUrl('ssl.privatekey.submit');
        return Api.put(route,
            {
                domain: domain,
                privateKey: privateKey
            });
    }
};
